<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>选题</el-breadcrumb-item>
        <el-breadcrumb-item>选题规划</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">选题规划</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="选题名称">
          <el-input
            v-model.trim="query.name_keyword"
            placeholder="输入选题名称"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="账号名称">
          <el-input
            v-model.trim="query.account_name_keyword"
            placeholder="输入账号名称"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">选题列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
          > </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="账号类型"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{formateType_code(scope.row.account_type_code)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="选题名称"
            width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="account_names"
            label="发布账号"
            width="210"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="today_publish_count"
            label="今日发布"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ready_publish_count"
            label="当前待发"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="total_writing_count"
            label="累计文案创作"
            width="100"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="300"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            width="120"
            label="创建人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="150"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openEditDialog(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.id)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button
          size="small"
          type="danger"
          @click="handleToDeleteAll()"
        >批量删除</el-button>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <SelectedTopicCreate
      :visible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <SelectedTopicEdit
      :visible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
      :content="editContent"
    />
  </div>
</template>

<script>

import { mediatopiclist, mediatopicDestroy, mediatopiclistDestroy } from "@/api/select";
import SelectedTopicCreate from "@/components/dialog/select/SelectedTopicCreate";
import SelectedTopicEdit from "@/components/dialog/select/SelectedTopicEdit";




export default {
  components: {
    SelectedTopicCreate,
    SelectedTopicEdit
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      editContent: {},
      chooseList: [],
    };
  },
  created() {
    this.fetchList()

    this.$store.dispatch('getAdminList')
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      mediatopiclist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediatopicDestroy({ id }).then((res) => {
          this.$nextTick(() => {
            this.fetchList();
          });
        });
      })
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*   4: "B站", */
        5: "知乎",
        /*     6: "抖音", */

      };
      return platform_code[val] || "";
    },
    openEditDialog(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        mediatopiclistDestroy({ ids }).then((res) => {
          this.fetchList();
        });
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },

  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
